import type { FunctionComponent, HTMLAttributes } from "preact";
import { $drawerNavOpen, setDrawerNavOpen } from "../../store/browser_var.ts";
import { useStore } from "@nanostores/preact";
import { Drawer } from "../drawer/drawer.tsx";
import { DrawerNavContent } from "./drawer_nav_content.tsx";

export type DrawerNavProps = HTMLAttributes;

export const DrawerNav: FunctionComponent<DrawerNavProps> = (_: DrawerNavProps) => {
    const drawerNavOpen = useStore($drawerNavOpen);

    return (
        <Drawer
            class="farpov_drawer_nav_container container"
            isOpen={drawerNavOpen}
            onClose={() => setDrawerNavOpen(false)}
        >
            <DrawerNavContent />
        </Drawer>
    );
};
export default DrawerNav;
